<template>
  <div class="edulist-wrap">
    <div class="edulist-item" :class="{'edulist-item-last': eduLength === index + 1}">
      <p class="edulist-time">{{getTime}}毕业于</p>
      <p class="edulist-name">
        <span>{{eduList.school}}</span>
        <span>{{eduList.professional}}专业</span>
      </p>
      <img
        src="../../../../assets/img/ic_edit.png"
        class="edulist-edit-icon"
        @click="editEdu">
    </div>
  </div>
</template>

<script>
import * as types from '../../../../store/mutation-types';
export default {
	props: ['eduList', 'index', 'eduLength'],
	methods: {
    /**
     * 进入教育经历编辑状态
     */
		editEdu() {
			window.scrollTo(0, document.documentElement.clientHeight);
			this.$store.commit(types.CHANGE_EDUTION, {
				key: 'eduIndex',
				value: this.index
			});
			this.$store.commit(types.CHANGE_EDUTION, {
				key: 'eduState',
				value: 2
			});
			this.$store.commit(types.CHECK_EDUINFO, {
				key: 'gradschool',
				value: this.eduList.school,
				state: true
			});
			this.$store.commit(types.CHECK_EDUINFO, {
				key: 'gradmajor',
				// value: this.eduList.profession || this.eduList.professional,
				value: this.eduList.professional,
				state: true
			});
			this.$store.commit(types.CHECK_EDUINFO, {
				key: 'gradtime',
				value: this.getTime,
				state: true
			});
		}
	},
	computed: {
    /**
     * 格式化毕业时间
     */
		getTime() {
			let timeArr = this.eduList.endDate.split('-');
			return timeArr.length > 1
				? `${timeArr[0]}年${timeArr[1]}月`
				: '';
		}
	}
};
</script>
<style lang="scss">
@import '../../../../assets/style/public.scss';
.edulist-wrap {
  padding: px2rem(30px) px2rem(30px) 0;
  .edulist-item {
    position: relative;
		margin-left: px2rem(15px);
    margin-bottom: px2rem(-20px);
    padding: px2rem(1px) 0 px2rem(70px) px2rem(25px);
    border-left: 1px solid rgba(227, 227, 228, 0.8);
    &.edulist-item-last {
      margin-bottom: 0;
      border-left: none;
      border-bottom: 1px solid #f3f3f3;
    }
  }
  .edulist-time {
    position: relative;
    margin-top: px2rem(-20px);
    margin-bottom: px2rem(10px);
    font-family: PingFangSC-Regular;
    font-size: px2rem(26px);
    color: #999;
    line-height: px2rem(40px);
    &::after {
      content: '';
      position: absolute;
      top: px2rem(8px);
      left: px2rem(-35px);
      width: px2rem(16px);
      height: px2rem(16px);
      border: 1px solid rgba(227, 227, 228, 0.8);
      background: #fff;
      border-radius: 50%;
    }
  }
  .edulist-name {
    overflow: hidden;
    font-family: PingFangSC-Regular;
    font-size: px2rem(30px);
    color: #151515;
    line-height: px2rem(40px);
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .edulist-edit-icon {
    position: absolute;
    top: px2rem(-20px);
    right: 0;
    display: inline-block;
    width: px2rem(35px);
    border-left: px2rem(20px) solid transparent;
    border-bottom: px2rem(20px) solid transparent;
  }
}
</style>



// WEBPACK FOOTER //
// index.vue?7b8e6aeb